const AuthOptions = {
    isBearer: false,
    isOneTimeLogin: false,
    fallbackToCookies: false,
};

export default AuthOptions;
